import { Component, Input, OnChanges } from '@angular/core';
import { getSummaryMetric } from './summary-kpi.utils';

@Component({
  selector: 'app-voltage-speed-summary-kpi',
  templateUrl: './summary-kpi.component.html',
  styleUrls: ['./summary-kpi.component.css']
})
export class VoltageSpeedSummaryKpiComponent implements OnChanges {
  @Input() value: number | null | undefined;
  @Input() percentage = false;
  @Input() title = '';
  @Input() description = '';

  metric: number | null = null;

  ngOnChanges(): void {
    this.metric = getSummaryMetric(this.value, this.percentage);
  }
}
